import { Stack } from 'expo-router'
import { ScrollView, Text, View } from 'react-native'
import { FormattedLogText } from '../../../components/game/FormattedLogText'

/** Exercises the real inline log renderer on devices without a seeded game. */
export default function DiceTilesPreview() {
  return (
    <ScrollView className="flex-1 bg-paper" contentContainerStyle={{ padding: 20, gap: 24 }}>
      <Stack.Screen options={{ title: 'Dice tile preview' }} />
      <Text className="font-stencil text-ink text-lg">Dice tiles</Text>
      {[16, 22, 26].map(size => (
        <View key={size} className="gap-2">
          <Text className="font-typed text-ink-soft">Dice size {size}</Text>
          <FormattedLogText className="font-typed text-ink" style={{ fontSize: 16, lineHeight: 28 }}
            text="Alice attacked Bob\n[6][4][2] vs [5][1] (1 lost, 1 lost)" diceSize={size} fontSize={16} color="#18170f" highlights={[{ text: 'Alice', color: '#b91c1c' }]} />
          <FormattedLogText className="font-typed text-ink" style={{ fontSize: 16, lineHeight: 28 }}
            text="Two-digit map dice [12][10] vs [9]" diceSize={size} fontSize={16} color="#18170f" />
        </View>
      ))}
      <View style={{ backgroundColor: '#18170f', borderRadius: 8, padding: 16 }}>
        <FormattedLogText style={{ fontFamily: 'Zilla Slab', color: '#e6e1c4', fontSize: 16, lineHeight: 28 }}
          text="Dark theme: [6][4] vs [3]" diceSize={26} fontSize={16} color="#e6e1c4" />
      </View>
    </ScrollView>
  )
}
